import Form from "react-bootstrap/Form";
import React, { useEffect } from "react";
import InputMask from "react-input-mask";
import { Row, Col } from "react-bootstrap";
import FormTexts from "../../../../constants/forms";
import Constants from "../../../../constants/constants";
import { formsLabelType } from "../../../../enums/index";
import { ToPersianNumber } from "../../../../functions/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NationalCodeSeparator } from "../../../../functions/index";
import {
  faCheckCircle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
const PartOneSecondPart = (props) => {
  const deathStatusMessage = (props) => {
    if (props.lastInquiry.DeathStatus === Constants.IsAlive) {
      return <b className="inquiry-info good">{Constants.TheyAreAlive}</b>;
    } else {
      return <b className="inquiry-info bad">{Constants.TheyAreDead}</b>;
    }
  };
  const SimilarityMessage = (percentage) => {
    if (parseInt(percentage) === 100) {
      return (
        <b className="inquiry-info good">
          {Constants.AuthHistoryArray.similarity}&nbsp;
          {ToPersianNumber(percentage)}&nbsp;
          {Constants.AuthHistoryArray.from}&nbsp;
          {ToPersianNumber(Constants.AuthHistoryArray.hundred)}
        </b>
      );
    } else if (parseInt(percentage) < 100 && parseInt(percentage) > 0) {
      return (
        <b className="inquiry-info ok">
          {" "}
          {Constants.AuthHistoryArray.similarity}&nbsp;
          {ToPersianNumber(percentage)}&nbsp;
          {Constants.AuthHistoryArray.from}&nbsp;
          {ToPersianNumber(Constants.AuthHistoryArray.hundred)}
        </b>
      );
    } else if (parseInt(percentage) === 0) {
      return (
        <b className="inquiry-info bad">
          {" "}
          {Constants.AuthHistoryArray.similarity}&nbsp;
          {ToPersianNumber(percentage)}&nbsp;
          {Constants.AuthHistoryArray.from}&nbsp;
          {ToPersianNumber(Constants.AuthHistoryArray.hundred)}
        </b>
      );
    }
  };
  useEffect(() => {
    if (props.lastInquiry) {
      if (props.lastInquiry.Message) {
        props.setAcceptBtn(true);
        props.setVerifyBtn(false);
        props.setRejectBtn(false);
      }
      if (
        props.lastInquiry.FirstNameSimilarity &&
        props.lastInquiry.LastNameSimilarity &&
        props.lastInquiry.FatherNameSimilarity &&
        props.lastInquiry.DeathStatus &&
        props.lastInquiry.BirthDate
      ) {
        let firstNameSimilarity = parseInt(
          props.lastInquiry.FirstNameSimilarity
        );
        let lastNameSimilarity = parseInt(props.lastInquiry.LastNameSimilarity);
        let fatherNameSimilarity = parseInt(
          props.lastInquiry.FatherNameSimilarity
        );
        if (!props.lastInquiry.DeathStatus === Constants.IsAlive) {
          props.setAcceptBtn(true);
          props.setVerifyBtn(true);
          props.setRejectBtn(false);
        } else if (
          firstNameSimilarity === 100 &&
          lastNameSimilarity === 100 &&
          fatherNameSimilarity === 100
        ) {
          props.setAcceptBtn(false);
          props.setVerifyBtn(true);
          props.setRejectBtn(true);
        } else if (
          firstNameSimilarity === 0 ||
          lastNameSimilarity === 0 ||
          fatherNameSimilarity === 0
        ) {
          props.setAcceptBtn(true);
          props.setVerifyBtn(false);
          props.setRejectBtn(false);
        } else if (
          firstNameSimilarity > 0 &&
          firstNameSimilarity <= 100 &&
          lastNameSimilarity > 0 &&
          lastNameSimilarity <= 100 &&
          fatherNameSimilarity > 0 &&
          fatherNameSimilarity <= 100
        ) {
          props.setAcceptBtn(false);
          props.setVerifyBtn(false);
          props.setRejectBtn(false);
        }
      }
    }
  }, [props]);
  return (
    <>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label temp-text-box-label">
            {FormTexts.Labels(formsLabelType.NationalCode())}:
          </Form.Label>
          <span className="temp-text-box dir-ltr">
            {props.customer.nationalCode ? (
              NationalCodeSeparator(props.customer.nationalCode)
            ) : (
              <br />
            )}
          </span>
          {props.lastInquiry &&
            props.lastInquiry.DeathStatus &&
            deathStatusMessage(props)}
          {!props.customer.nationalCode && (
            <b className="inquiry-info bad">{Constants.NoNationalCodeError}</b>
          )}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Name())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={props.customer.firstName ? props.customer.firstName : ""}
            onChange={(e) => {
              props.setCustomer({
                ...props.customer,
                firstName: e.target.value,
              });
            }}
          />
          {props.lastInquiry &&
            props.lastInquiry.FirstNameSimilarity &&
            SimilarityMessage(props.lastInquiry.FirstNameSimilarity)}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Family())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={props.customer.lastName ? props.customer.lastName : ""}
            onChange={(e) => {
              props.setCustomer({
                ...props.customer,
                lastName: e.target.value,
              });
            }}
          />
          {props.lastInquiry &&
            props.lastInquiry.LastNameSimilarity &&
            SimilarityMessage(props.lastInquiry.LastNameSimilarity)}
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label birthday-input-label">
            {FormTexts.Labels(formsLabelType.BirthDay())}:
          </Form.Label>
          <InputMask
            mask="9999/99/99"
            className="normal-input from-control birthday-input"
            type="text"
            value={
              props.customer.persianBirthDate
                ? props.customer.persianBirthDate
                : ""
            }
            onChange={(e) => {
              props.setCustomer({
                ...props.customer,
                persianBirthDate: e.target.value,
              });
            }}
          />
    </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.FatherName())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={props.customer.fatherName ? props.customer.fatherName : ""}
            onChange={(e) => {
              props.setCustomer({
                ...props.customer,
                fatherName: e.target.value,
              });
            }}
          />
          {props.lastInquiry &&
            props.lastInquiry.FatherNameSimilarity &&
            SimilarityMessage(props.lastInquiry.FatherNameSimilarity)}
        </Form.Group>
      </Row>
      <Row className="mb-2 mt-5">
        <Form.Group as={Col}>
          <Form.Label className="input-label detail-text-box-label">
            {FormTexts.Labels(formsLabelType.Mobile())}:
          </Form.Label>
          <span className="detail-text-box">
            {props.customer.mobile
              ? ToPersianNumber(props.customer.mobile)
              : ""}
            &nbsp;&nbsp;&nbsp;
            {props.customer.mobileVerificationStatus === "Verified" ? (
              <FontAwesomeIcon className="verified" icon={faCheckCircle} />
            ) : props.customer.mobileVerificationStatus === "NotVerified" ? (
              <FontAwesomeIcon
                className="not verified"
                icon={faExclamationCircle}
              />
            ) : (
              ""
            )}
          </span>
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label detail-text-box-label">
            {FormTexts.Labels(formsLabelType.Email())}:
          </Form.Label>
          <span className="detail-text-box">
            {props.customer.email ? props.customer.email : ""}&nbsp;&nbsp;&nbsp;
            {props.customer.emailVerificationStatus === "Verified" ? (
              <FontAwesomeIcon className="verified" icon={faCheckCircle} />
            ) : props.customer.emailVerificationStatus === "NotVerified" ? (
              <FontAwesomeIcon
                className="not verified"
                icon={faExclamationCircle}
              />
            ) : (
              ""
            )}
          </span>
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label detail-text-box-label">
            {FormTexts.Labels(formsLabelType.Address())}:
          </Form.Label>
          <span className="detail-text-box">
            {props.customer.state
              ? `${Constants.State} ${props.customer.state} ${Constants.Dash}`
              : ""}
            {props.customer.city
              ? `${Constants.City} ${props.customer.city} ${Constants.Dash}`
              : ""}
            {props.customer.residenceAddress
              ? `${Constants.ResidenceAddress} ${props.customer.residenceAddress} ${Constants.Dash}`
              : ""}
            {props.customer.street ? `${Constants.Street} ${props.customer.street} ${Constants.Dash}`:""}
            {props.customer?.houseNumber ?`${Constants.HouseNumber}: ${props.customer.houseNumber}`: "---"}

            {props.customer.postalCode
              ? `${Constants.Dash} ${Constants.PostalCode}${Constants.AuthHistoryArray.column} ${props.customer.postalCode}`
              : ""}
          </span>
        </Form.Group>
      </Row>
    </>
  );
};
export default PartOneSecondPart;
